import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganization } from '../contexts/OrganizationContext';
import PlatformLayout from './PlatformLayout';
import PlatformText from './PlatformText';
import PlatformButton from './PlatformButton';
import './DashboardLocked.css';
import { useTranslation } from '../hooks/useTranslation';

const DashboardLocked = () => {
  const navigate = useNavigate();
  const { organizationData, trialStatus } = useOrganization();
  const { t } = useTranslation('dashboard');

  const subscriptionPlan =
    trialStatus?.subscriptionPlan ||
    organizationData?.subscriptionPlan ||
    'basic';

  return (
    <PlatformLayout className="dashboard-locked">
      <div className="dashboard-locked-card">
        <div className="dashboard-locked-header">
          <div className="dashboard-locked-badge">
            {t('locked.badge')}
          </div>
          <PlatformText variant="h1" className="dashboard-locked-title">
            {t('locked.title')}
          </PlatformText>
          <PlatformText variant="body" className="dashboard-locked-subtitle">
            {t('locked.subtitle')}
          </PlatformText>
        </div>

        <div className="dashboard-locked-plan">
          <PlatformText variant="caption" className="dashboard-locked-plan-label">
            {t('locked.currentPlan')}
          </PlatformText>
          <PlatformText variant="h3" className="dashboard-locked-plan-name">
            {subscriptionPlan || 'Basic'}
          </PlatformText>
        </div>

        <div className="dashboard-locked-feature-list">
          <PlatformText variant="body" className="dashboard-locked-feature-text">
            {t('locked.feature1')}
          </PlatformText>
          <PlatformText variant="body" className="dashboard-locked-feature-text">
            {t('locked.feature2')}
          </PlatformText>
          <PlatformText variant="body" className="dashboard-locked-feature-text">
            {t('locked.feature3')}
          </PlatformText>
        </div>

        <div className="dashboard-locked-actions">
          <PlatformButton
            className="dashboard-locked-upgrade"
            onClick={() => navigate('/account-plan')}
          >
            {t('locked.upgradeCta')}
          </PlatformButton>
          <PlatformButton
            variant="outline"
            className="dashboard-locked-back"
            onClick={() => navigate('/orders')}
          >
            {t('locked.backCta')}
          </PlatformButton>
        </div>
      </div>
    </PlatformLayout>
  );
};

export default DashboardLocked;

